module.exports = __webpack_public_path__ + "assets/prevmini.240e0bc8.svg";